import { Award, HeartHandshake } from 'lucide-react'
import { RecognitionSetupFields } from '@/components/features/recognition/RecognitionSetupFields'
import {
  defaultRecognitionValuesConfig,
  saveRecognitionValues,
  validateRecognitionValues,
  valuesConfigFrom,
  valuesErrorsFromApi
} from '@/components/features/recognition/recognitionUtils'
import { sdk } from '@/lib/sdk'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const RecognitionPage = lazyPage(() => import('@/pages/Recognition'), 'RecognitionPage')

export const recognitionModule: ModuleDefinition = {
  key: 'recognition',
  icon: Award,
  iconName: 'award',
  namespaces: ['recognition'],
  ready: true,
  ListPage: RecognitionPage,
  /* The community values are optional and short: on the details step (PADROES-UI section 14), saved by their own endpoint. */
  setup: {
    wizardStep: 'details',
    defaultConfig: () => defaultRecognitionValuesConfig(),
    validate: (config, t) => validateRecognitionValues(config, t),
    Fields: RecognitionSetupFields,
    persist: {
      type: 'endpoint',
      save: (spaceId, config) => saveRecognitionValues(config, spaceId),
      load: async (spaceId) => valuesConfigFrom(await sdk.recognitions.listValues(true, spaceId)),
      errorsFromSaveFailure: (err) => valuesErrorsFromApi(err)
    }
  },
  /* Feedback events (the feedbacks module) share the recognition block. */
  workflow: {
    trigger: { block: 'recognition', icon: HeartHandshake, hrPrefixes: ['recognition.', 'feedback.'] },
    spaceActions: ['recognition.give']
  }
}
